<template>
  <div class="landing-page">
    <!-- 全屏首屏：无导航栏，点击「进入博客」或「向下滚动」均跳转到 /blog，体验一致 -->
    <div class="hero-section">
      <div class="hero-background" :style="backgroundStyle">
        <div class="hero-overlay"></div>
      </div>
      <div class="hero-content">
        <div class="avatar-container" @click="navigateToBlog">
          <img src="https://images.unsplash.com/photo-1506744038136-46273834b3fb?w=400&h=400&fit=crop" alt="风景头像" class="avatar landscape-avatar"/>
        </div>
        <h1 class="hero-title">欢迎来到苏七的博客</h1>
        <p class="hero-subtitle">那些生死悲欢，你以为是入世一生，可月亮见过太多，知道那只是弹指一瞬</p>
        <div class="hero-actions">
          <button class="btn-primary" @click="navigateToBlog">进入博客</button>
          <button class="btn-secondary" @click="navigateToBlog">了解更多</button>
        </div>
      </div>
      <div class="scroll-indicator" @click="navigateToBlog">
        <span class="scroll-text">向下滚动</span>
        <div class="scroll-arrow">
          <i class="el-icon-arrow-down"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandingPage',
  data() {
    return {
      // 可以配置多张背景图轮播
      backgrounds: [
        'https://images.unsplash.com/photo-1519681393784-d120267933ba?w=1920&q=80',
        'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1920&q=80',
        'https://images.unsplash.com/photo-1510915228340-29c85a43dcfe?w=1920&q=80'
      ],
      currentBg: 0,
      timer: null
    }
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url(${this.backgrounds[this.currentBg]})`
      }
    }
  },
  mounted() {
    // 自动轮播背景图
    this.timer = setInterval(() => {
      this.currentBg = (this.currentBg + 1) % this.backgrounds.length
    }, 8000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  methods: {
    navigateToBlog() {
      this.$router.push('/blog')
    }
  }
}
</script>

<style scoped>
.landing-page {
  min-height: 100vh;
}

/* 全屏首屏区域 */
.hero-section {
  position: relative;
  height: 100vh;
  min-height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

/* 背景图 */
.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  transition: background-image 1.5s ease-in-out;
  transform: scale(1.05);
  animation: slowZoom 20s ease-in-out infinite alternate;
}

@keyframes slowZoom {
  from { transform: scale(1.05); }
  to { transform: scale(1.15); }
}

/* 暗色遮罩 */
.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(30, 41, 59, 0.7) 0%,
    rgba(51, 65, 85, 0.5) 50%,
    rgba(30, 41, 59, 0.7) 100%
  );
}

/* 中央内容 */
.hero-content {
  position: relative;
  z-index: 10;
  text-align: center;
  color: white;
  padding: 0 24px;
  max-width: 800px;
  animation: fadeInUp 1s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 头像 */
.avatar-container {
  margin-bottom: 24px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.avatar-container:hover {
  transform: scale(1.05);
}

.avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  background: white;
  object-fit: cover;
}

.landscape-avatar {
  border: 3px solid rgba(0, 255, 245, 0.4);
  box-shadow: 0 0 20px rgba(0, 255, 245, 0.3), 0 8px 32px rgba(0, 0, 0, 0.4);
}

/* 标题 */
.hero-title {
  font-size: 42px;
  font-weight: 600;
  margin-bottom: 16px;
  letter-spacing: 2px;
  text-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
}

/* 副标题 */
.hero-subtitle {
  font-size: 16px;
  line-height: 1.8;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 32px;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

/* 按钮组 */
.hero-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn-primary, .btn-secondary {
  padding: 12px 32px;
  border-radius: 30px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  letter-spacing: 1px;
}

.btn-primary {
  background: linear-gradient(135deg, var(--accent-warm) 0%, #c9956b 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(212, 165, 116, 0.4);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(212, 165, 116, 0.5);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.15);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateY(-2px);
}

/* 滚动指示器 */
.scroll-indicator {
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  z-index: 10;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% { transform: translateX(-50%) translateY(0); }
  40% { transform: translateX(-50%) translateY(-10px); }
  60% { transform: translateX(-50%) translateY(-5px); }
}

.scroll-text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 8px;
  letter-spacing: 2px;
  text-transform: uppercase;
}

.scroll-arrow {
  width: 40px;
  height: 40px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.scroll-arrow:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.5);
}

.scroll-arrow i {
  font-size: 16px;
  color: white;
}

/* 响应式 */
@media (max-width: 768px) {
  .hero-title {
    font-size: 28px;
  }
  
  .hero-subtitle {
    font-size: 14px;
  }
  
  .avatar {
    width: 80px;
    height: 80px;
  }
  
  .btn-primary, .btn-secondary {
    padding: 10px 24px;
    font-size: 13px;
  }
}
</style>